import { render, staticRenderFns } from "./ydyhxsxy.vue?vue&type=template&id=ed226bec&scoped=true"
import script from "./ydyhxsxy.vue?vue&type=script&lang=js"
export * from "./ydyhxsxy.vue?vue&type=script&lang=js"
import style0 from "./ydyhxsxy.vue?vue&type=style&index=0&id=ed226bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed226bec",
  null
  
)

export default component.exports